// @flow

/**
 * External dependencies
 */
import styled, { css } from 'styled-components';

/**
 * Style
 */
export const Root = styled.div`
	-webkit-overflow-scrolling: touch;
	height: 100vh;
	left: 0;
	overflow: auto;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 9999;

	${ props => props.notFixedOnMob && css`
		height: auto;
		left: auto;
		position: relative;
		top: auto;

		@media ( min-width: 500px ) {
			position: fixed;
		}
	` }

	${ props => props.freeScroll && css`
		height: auto;
		left: auto;
		min-height: 100vh;
		position: relative;
		top: auto;

		@media ( min-width: 500px ) {
			min-height: auto;
			position: fixed;
		}
	` }

	@media ( min-width: 500px ) {
		width: 375px;
		height: 667px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		bottom: auto;
		right: auto;
	}
`;



// WEBPACK FOOTER //
// ./src/style/index.js